import { useState } from 'react';
import { boards } from '@/mocks/haijiao';

const icons = [
  'ri-chat-4-line',
  'ri-cpu-line',
  'ri-movie-2-line',
  'ri-gamepad-line',
  'ri-briefcase-line',
  'ri-camera-lens-line',
  'ri-heart-3-line',
  'ri-restaurant-line',
];

function SectionHead({
  eyebrow,
  title,
  moreHref,
}: {
  eyebrow: string;
  title: string;
  moreHref: string;
}) {
  return (
    <div className="flex items-end justify-between gap-4">
      <div>
        <p className="flex items-center gap-2 text-sm font-semibold text-orange-600">
          <i className="ri-fire-fill"></i> {eyebrow}
        </p>
        <h2 className="mt-2 text-xl font-bold tracking-tight text-stone-900 md:text-2xl">{title}</h2>
      </div>
      <a
        href={moreHref}
        className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-stone-200 bg-white px-3 py-1.5 text-xs text-stone-600 transition-colors hover:border-orange-400 hover:text-orange-700"
      >
        查看全部 <i className="ri-arrow-right-s-line text-sm"></i>
      </a>
    </div>
  );
}

export default function Boards() {
  const [followed, setFollowed] = useState<Record<number, boolean>>({ 0: true });

  return (
    <section id="boards" className="border-b border-stone-200/80 bg-white">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <SectionHead eyebrow="热门板块导航" title="先看这里：海角社区的高人气板块都在聊什么" moreHref="#categories" />

        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {boards.map((b, i) => {
            const isOn = !!followed[i];
            return (
              <div
                key={b.name}
                className="group flex flex-col rounded-2xl border border-stone-200 bg-[#fdfaf6] p-4 transition-colors hover:border-orange-300 hover:bg-orange-50/50"
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${b.tint}`}>
                    <i className={`${icons[i % icons.length]} text-lg`}></i>
                  </span>
                  <span className="rounded-full bg-orange-100 px-2 py-0.5 text-[11px] font-medium text-orange-700">
                    {b.tag}
                  </span>
                </div>
                <h3 className="mt-3 text-sm font-bold text-stone-900 md:text-base">{b.name}</h3>
                <p className="mt-1 flex-1 text-xs leading-relaxed text-stone-500">{b.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="flex items-center gap-1 text-xs text-stone-400">
                    <i className="ri-community-line"></i> 今日活跃
                  </span>
                  <button
                    onClick={() => setFollowed((p) => ({ ...p, [i]: !p[i] }))}
                    className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                      isOn
                        ? 'bg-stone-100 text-stone-500 hover:bg-stone-200'
                        : 'bg-orange-600 text-white hover:bg-orange-700'
                    }`}
                  >
                    {isOn ? '已关注' : '+ 关注'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}